import { createGradient } from "@/utils/createGradient";

export const red = {
  default: "rgba(210, 63, 63, 1)",
  half: "rgba(210, 63, 63, 0.85)",
  quarter: "rgba(210, 63, 63, 0.5)",
  zero: "rgba(210, 63, 63, 0.25)",
};

export const blue = {
  default: "rgba(14, 156, 255, 1)",
  half: "rgba(14, 156, 255, 0.5)",
  quarter: "rgba(14, 156, 255, 0.25)",
  zero: "rgba(14, 156, 255, 0)",
};

export const gradientRed = createGradient({
  default: red.default,
  half: red.half,
  quarter: red.quarter,
  zero: red.zero,
});

export const gradientBlue = createGradient({
  default: blue.default,
  half: blue.half,
  quarter: blue.quarter,
  zero: blue.zero,
});
